import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=ad145046&scoped=true&"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PasswordUpdate.vue?vue&type=style&index=0&id=ad145046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad145046",
  null
  
)

export default component.exports